<clr-tabs style="padding: 0 10px 10px">
  <clr-tab>
    <button clrTabLink>{{ 'Auftragsliste' | mrTranslate }}</button>
    <clr-tab-content *clrIfActive>
      <app-auftragsliste [viewType]="'standard'" />
    </clr-tab-content>
  </clr-tab>

  @if (isGenehmiger()) {
    <clr-tab>
      <button clrTabLink>{{ 'Zu genehmigende Aufträge' | mrTranslate }}</button>
      <clr-tab-content *clrIfActive>
        <app-auftragsliste [viewType]="'genehmigen'" />
      </clr-tab-content>
    </clr-tab>
  }

  @if (isRueckmelder()) {
    <clr-tab>
      <button clrTabLink>{{ 'Rückzumeldende Aufträge' | mrTranslate }}</button>
      <clr-tab-content *clrIfActive>
        <app-auftragsliste [viewType]="'rueckmelden'" />
      </clr-tab-content>
    </clr-tab>
  }

  <clr-tab>
    <button clrTabLink>{{ 'Kosten' | mrTranslate }}</button>
    <clr-tab-content *clrIfActive>
      <app-kostenliste (dataRefresh)="reloadTabs()" />
    </clr-tab-content>
  </clr-tab>
</clr-tabs>
